/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeasurementUIDTOV0 } from './measurementUIDTOV0';
import { AirChangeRateUIDTOV0 } from './airChangeRateUIDTOV0';
import { HeatingFuelTypeCodeUIDTOV0 } from './heatingFuelTypeCodeUIDTOV0';


export interface EnergyFeatureUIDTOV0 { 
    energySavedOrGenerated?: MeasurementUIDTOV0;
    savedOrGeneratedFuel?: HeatingFuelTypeCodeUIDTOV0;
    energyUsed?: MeasurementUIDTOV0;
    energyUsedFuel?: HeatingFuelTypeCodeUIDTOV0;
    airChangeRates?: Array<AirChangeRateUIDTOV0>;
}
export namespace EnergyFeatureUIDTOV0 {
}


